module.exports = __webpack_public_path__ + "img/jinmatai-logo.3637a3d7.png";